import {
    Slider as PrivateSlider,
    SliderTrack,
    SliderFilledTrack,
    SliderThumb
} from '@chakra-ui/core';

export const Slider = { // eslint-disable-line import/prefer-default-export
    Container: PrivateSlider,
    Track: SliderTrack,
    FilledTrack: SliderFilledTrack,
    Thumb: SliderThumb
};
